// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Activity from "./activity.js"
import Survey from "./survey.js"

const modelClassData = {
  "attributes": {
    "activity_id": {
      "column": {
        "default": null,
        "name": "activity_id",
        "null": false,
        "type": "uuid"
      },
      "name": "activity_id",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "fill_in_at_registration": {
      "column": {
        "default": false,
        "name": "fill_in_at_registration",
        "null": false,
        "type": "boolean"
      },
      "name": "fill_in_at_registration",
      "selected_by_default": null,
      "translated": null
    },
    "required": {
      "column": {
        "default": false,
        "name": "required",
        "null": false,
        "type": "boolean"
      },
      "name": "required",
      "selected_by_default": null,
      "translated": null
    },
    "survey_id": {
      "column": {
        "default": null,
        "name": "survey_id",
        "null": false,
        "type": "uuid"
      },
      "name": "survey_id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ActivitySurvey",
  "collectionKey": "activity_surveys",
  "collectionName": "activity_surveys",
  "i18nKey": "activity_survey",
  "camelizedLower": "activitySurvey",
  "name": "ActivitySurvey",
  "nameDasherized": "activity-survey",
  "pluralName": "activity_surveys",
  "ransackable_associations": [
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "activity_id",
      "name": "activity",
      "macro": "belongs_to",
      "resource_name": "Activity",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "activity_id",
      "column": {
        "default": null,
        "name": "activity_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "fill_in_at_registration",
      "column": {
        "default": false,
        "name": "fill_in_at_registration",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_activity_id",
      "column": {
        "default": null,
        "name": "old_activity_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_survey_id",
      "column": {
        "default": null,
        "name": "old_survey_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "required",
      "column": {
        "default": false,
        "name": "required",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "survey_id",
      "column": {
        "default": null,
        "name": "survey_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "activity_id",
      "name": "activity",
      "macro": "belongs_to",
      "resource_name": "Activity",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    }
  ],
  "paramKey": "activity_survey",
  "primaryKey": "id"
}

/** Frontend model for ActivitySurvey. */
export default class ActivitySurvey extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  activityId() {
    return this.readAttributeUnderscore("activity_id")
  }

  /** @returns {boolean} */
  hasActivityId() {
    const value = this.activityId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  fillInAtRegistration() {
    return this.readAttributeUnderscore("fill_in_at_registration")
  }

  /** @returns {boolean} */
  hasFillInAtRegistration() {
    const value = this.fillInAtRegistration()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  required() {
    return this.readAttributeUnderscore("required")
  }

  /** @returns {boolean} */
  hasRequired() {
    const value = this.required()

    return this._isPresent(value)
  }

  /** @returns {string} */
  surveyId() {
    return this.readAttributeUnderscore("survey_id")
  }

  /** @returns {boolean} */
  hasSurveyId() {
    const value = this.surveyId()

    return this._isPresent(value)
  }

  /** @returns {import("./activity.js").default | null} */
  activity() {
    return this._readBelongsToReflection({modelClass: Activity, reflectionName: "activity"})
  }

  /** @returns {Promise<import("./activity.js").default | null>} */
  loadActivity() {
    if (!("activityId" in this)) throw new Error("Foreign key method wasn't defined: activityId")

    const id = this.activityId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "activity",
        model: this,
        modelClass: Activity
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./activity.js").default | null>} */
  ensureActivityLoaded() {
    return this.ensureAssociationLoaded("activity")
  }

  /** @returns {import("./survey.js").default | null} */
  survey() {
    return this._readBelongsToReflection({modelClass: Survey, reflectionName: "survey"})
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  loadSurvey() {
    if (!("surveyId" in this)) throw new Error("Foreign key method wasn't defined: surveyId")

    const id = this.surveyId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "survey",
        model: this,
        modelClass: Survey
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  ensureSurveyLoaded() {
    return this.ensureAssociationLoaded("survey")
  }
}
